/**
 * MessageStatus - Clean status indicators for messages
 */

import React from 'react';
import './MessageStatus.css';

const MessageStatus = ({ status, isInbound, statusDescription }) => {
  // Don't show status for inbound messages
  if (isInbound) {
    return null;
  }

  const renderStatusIcon = () => {
    switch (status) {
      case 'DELIVERED':
        return (
          <span className="message-status delivered" title="Delivered">
            <svg width="16" height="10" viewBox="0 0 16 10" fill="none">
              {/* Double checkmark */}
              <path d="M1 5L4 8L9 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7 5L10 8L15 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        );
      
      case 'SENT':
        return (
          <span className="message-status sent" title="Sent">
            <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
              {/* Single checkmark */}
              <path d="M1 5L4 8L11 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        );
      
      case 'QUEUED':
        return (
          <span className="message-status queued" title="Queued">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              {/* Dotted circle */}
              <circle cx="5" cy="5" r="4" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
            </svg>
          </span>
        );
      
      case 'FAILED':
        return (
          <span className="message-status failed" title="Failed">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              {/* X mark */}
              <path d="M2 2L8 8M8 2L2 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg> 
            {statusDescription && <span className="status-description">{statusDescription}</span>}
          </span>
        );
      
      default:
        return null;
    }
  };

  return renderStatusIcon();
};

export default MessageStatus;

